var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefualtBodyNewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 174,
    height: 40,
    viewBox: "0 0 174 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 179052"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 1945",
    style: {
      fill: "#fff",
      stroke: "#e1e1e1",
      strokeDasharray: "4 4"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M0 0h174v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.5.5h173v39H.5z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29144",
    d: "M-12.93 0v-8.46h3.384a3.122 3.122 0 0 1 2.022.582 1.981 1.981 0 0 1 .714 1.626 1.957 1.957 0 0 1-.36 1.188 2.056 2.056 0 0 1-1 .72 2.1 2.1 0 0 1 1.146.708 2.024 2.024 0 0 1 .414 1.308A2.106 2.106 0 0 1-7.338-.6 3.173 3.173 0 0 1-9.4 0zm.96-4.68h2.28q1.908 0 1.908-1.488t-1.908-1.5h-2.28zm0 3.888h2.47q1.92 0 1.92-1.548T-9.5-3.888h-2.47zm9.444.9A2.829 2.829 0 0 1-4-.264a2.506 2.506 0 0 1-.966-1.05 3.517 3.517 0 0 1-.342-1.6 3.517 3.517 0 0 1 .342-1.6A2.506 2.506 0 0 1-4-5.568a2.829 2.829 0 0 1 1.474-.372 2.837 2.837 0 0 1 1.47.372 2.494 2.494 0 0 1 .972 1.05 3.517 3.517 0 0 1 .342 1.6 3.517 3.517 0 0 1-.342 1.6 2.494 2.494 0 0 1-.972 1.05 2.837 2.837 0 0 1-1.47.376zm0-.78a1.627 1.627 0 0 0 1.308-.582 2.5 2.5 0 0 0 .492-1.662 2.5 2.5 0 0 0-.492-1.668 1.634 1.634 0 0 0-1.308-.576 1.63 1.63 0 0 0-1.314.576 2.522 2.522 0 0 0-.486 1.668 2.526 2.526 0 0 0 .486 1.662 1.623 1.623 0 0 0 1.314.582zm6.468.78A2.474 2.474 0 0 1 2.58-.264a2.442 2.442 0 0 1-.9-1.05 3.741 3.741 0 0 1-.318-1.6A3.772 3.772 0 0 1 1.68-4.53a2.4 2.4 0 0 1 .9-1.044 2.5 2.5 0 0 1 1.362-.366 2.377 2.377 0 0 1 1.206.3 1.864 1.864 0 0 1 .774.828V-8.46h.972V0h-.948v-1.068a1.9 1.9 0 0 1-.78.864 2.361 2.361 0 0 1-1.224.312zm.2-.78a1.627 1.627 0 0 0 1.308-.582 2.5 2.5 0 0 0 .492-1.662 2.5 2.5 0 0 0-.492-1.668 1.634 1.634 0 0 0-1.304-.576 1.63 1.63 0 0 0-1.314.576 2.522 2.522 0 0 0-.486 1.668 2.526 2.526 0 0 0 .486 1.662 1.623 1.623 0 0 0 1.314.582zM9.39 2.16l1-2.256-2.464-5.736h1.056L10.914-1.1l1.944-4.728h1.02L10.41 2.16z",
    transform: "translate(87 24)",
    style: {
      fill: "#484848"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefualtBodyNewIcon);
export default __webpack_public_path__ + "static/media/defualt_body_new_icon.43349a19b9fe0a57e619e3df09b25b6d.svg";
export { ForwardRef as ReactComponent };